import { render, staticRenderFns } from "./CompaniesUploaded.vue?vue&type=template&id=6b26c524&scoped=true&"
import script from "./CompaniesUploaded.vue?vue&type=script&lang=js&"
export * from "./CompaniesUploaded.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesUploaded.vue?vue&type=style&index=0&id=6b26c524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b26c524",
  null
  
)

export default component.exports